define("shared/modifiers/scroll-to-bottom", ["exports", "ember-modifier"], function (_exports, _emberModifier) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-modifier"eaimeta@70e063a35619d71f
  /**
   * ScrollToBottomModifier will automatically scroll to the bottom of the chosen element.
   *
   * Usage:
   * Will force the targeted element to scroll to the bottom when the modifier is loaded in
   * <RandomElement {{scroll-to-bottom "#targetId"}} />
   * or
   * <RandomElement {{scroll-to-bottom ".targetClass"}} />
   */
  class ScrollToBottomModifier extends _emberModifier.default {
    modify(_element, _ref) {
      let [elementSelector] = _ref;
      const targetElement = document.querySelector(elementSelector);
      if (targetElement) {
        targetElement.scrollTop = targetElement.scrollHeight;
      }
    }
  }
  _exports.default = ScrollToBottomModifier;
});